import {cs}          from "../../react/chain-services";
import {fragments}   from "../../react/fragments";
import {OnMounted}   from "../../react/on-mounted";
import {OnUnmounted} from "../../react/on-unmounted";
import {Static}      from "../../react/static";
import {UseState}    from "../../react/use-state";

export const ObserveWindowSize2 = ({next}) => cs(
    ["size", (_, next) => UseState({
        getInitValue: getSize,
        next,
    })],
    ({size}, next) => cs(
        ["listener", (_, next) => Static({
            getInitValue: () => () => size.onChange(getSize()),
            next,
        })],
        ({listener}) => fragments(
            OnMounted({
                action: () => window.   addEventListener("resize", listener, true),
            }),
            OnUnmounted({
                action: () => window.removeEventListener("resize", listener, true),
            }),
            next(),
        )
    ),
    ({size}) => next(size.value),
);

const getSize = () => ({
    width : document.documentElement.clientWidth,
    height: document.documentElement.clientHeight,
});
